export const teamConfig: Record<string, { name: string; tags: string[] }> = {
	giants: { name: "巨人", tags: ["巨人", "巨人軍", "読売巨人軍", "読売ジャイアンツ", "ジャイアンツ", "読売", "giants", "Giants", "GIANTS"] },
	tigers: { name: "阪神", tags: ["阪神", "タイガース", "阪神タイガース", "tigers", "Tigers", "TIGERS"] },
	dragons: { name: "中日", tags: ["中日", "ドラゴンズ", "中日ドラゴンズ", "dragons", "Dragons", "DRAGONS"] },
	carp: { name: "広島", tags: ["広島", "広島カープ", "広島東洋", "広島東洋カープ", "カープ", "carp", "Carp", "CARP"] },
	swallows: { name: "ヤクルト", tags: ["ヤクルト", "ヤクルトスワローズ", "東京ヤクルト", "東京ヤクルトスワローズ", "スワローズ", "swallows", "Swallows", "SWALLOWS"] },
	dena: { name: "DeNA", tags: ["横浜", "横浜DeNA", "横浜DeNAベイスターズ", "DeNAベイスターズ", "ベイスターズ", "DeNA", "dena", "DENA"] },

	eagles: { name: "楽天", tags: ["楽天", "楽天イーグルス", "東北楽天", "東北楽天イーグルス", "東北楽天ゴールデンイーグルス", "eagles", "Eagles", "EAGLES"] },
	hawks: { name: "ソフトバンク", tags: ["ソフトバンク", "ソフトバンクホークス", "ホークス", "福岡ソフトバンク", "福岡ソフトバンクホークス", "軟銀", "SB", "hawks", "Hawks", "HAWKS"] },
	fighters: { name: "日本ハム", tags: ["日ハム", "日本ハム", "日本ハムファイターズ", "北海道日ハム", "北海道日本ハム", "北海道日本ハムファイターズ", "日公", "ファイターズ", "fighters", "Fighters", "FIGHTERS"] },
	lions: { name: "西武", tags: ["西武", "西武ライオンズ", "埼玉西武", "埼玉西武ライオンズ", "lions", "Lions", "LIONS"] },
	marines: { name: "ロッテ", tags: ["ロッテ", "千葉ロッテ", "千葉ロッテマリーンズ", "lotte", "Lotte", "LOTTE", "marines", "Marines", "MARINES"] },
	buffaloes: { name: "オリックス", tags: ["オリックス", "オリックス・バファローズ", "オリックスバファローズ", "オリックス・バッファローズ", "オリックスバッファローズ", "バファローズ", "バッファローズ", "orix", "Orix", "ORIX", "buffaloes", "Buffaloes", "BUFFALOSE"] },
};

const tagToTeamSlug = new Map<string, string>(
	Object.entries(teamConfig).flatMap(([slug, { tags }]) =>
		tags.map(tag => [tag, slug] as const),
	),
);

export function getTeamInfo(slug: string | undefined) {
	return teamConfig[slug ?? ""] ?? { name: slug ?? "不明", tags: [] };
}

export function getTeamSlugByTag(tagName: string): string | null {
	return tagToTeamSlug.get(tagName) ?? null;
}

export function resolveTagHref(tagName: string): string {
	const teamSlug = getTeamSlugByTag(tagName);
	return teamSlug ? `/team/${teamSlug}` : `/tags/${encodeURIComponent(tagName)}`;
}

